import { render } from "./AddOrderPointsModal.vue?vue&type=template&id=d6fbf6d8"
import script from "./AddOrderPointsModal.vue?vue&type=script&lang=js"
export * from "./AddOrderPointsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__